import { Directive, ElementRef, inject, afterRenderEffect, HostListener } from "@angular/core";

@Directive({
    selector: "[wk-auto-width]",
    exportAs: "wkAutoWidth",
})
export class WkAutoWidthDirective {
    private readonly el = inject(ElementRef<HTMLElement>);

    constructor() {
        afterRenderEffect(() => {
            this.check();
        });
    }

    private check() {
        const el = this.el.nativeElement;
        if (!el) return;

        const input = el.querySelector("input") as HTMLInputElement | null;
        if (!input) return;

        if (input.value) {
            input.style.width = "120px";
            return;
        }

        const styles = window.getComputedStyle(input);
        const font = `${styles.fontWeight} ${styles.fontSize} ${styles.fontFamily}`;

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (context) {
            const text = input.value || input.placeholder || "";
            context.font = font;
            const textWidth = context.measureText(text).width + 6;

            const paddingLeft = parseFloat(styles.paddingLeft);
            const paddingRight = parseFloat(styles.paddingRight);
            const borderLeft = parseFloat(styles.borderLeftWidth);
            const borderRight = parseFloat(styles.borderRightWidth);

            const totalWidthInPx = textWidth + paddingLeft + paddingRight + borderLeft + borderRight;

            input.style.width = `${totalWidthInPx}px`;
        }
    }

    @HostListener("valueChange")
    onInput() {
        this.check();
    }
}
